import isEmpty from 'lodash-es/isEmpty'

const textLengthMatch = (text: string, optional: boolean, minLength: number = 0, maxLength: number = 0): boolean => {
    if (isEmpty(text) || isEmpty((text || '').trim())) return optional
    if (minLength !== 0 && text.length < minLength) return false
    if (maxLength !== 0 && text.length > maxLength) return false
    return true
}

// something@domain.zone without spaces; the backend checks station contacts with the same rule
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const isEmail = (text: string, optional: boolean, multiple: boolean = false): boolean => {
    if (isEmpty(text) || isEmpty((text || '').trim())) return optional

    if (multiple) {
        // the mail sender splits recipients by «;» and «,»
        const emails = text
            .split(/[,;]/)
            .map((email) => email.trim())
            .filter(Boolean)
        return emails.every((email) => EMAIL_REGEX.test(email))
    }
    return EMAIL_REGEX.test(text)
}

const isDigits = (text: string, optional: boolean): boolean => {
    if (text === null || text === undefined) return optional

    if (typeof text !== 'string') {
        text = (text as any).toString()
    }

    if (isEmpty((text || '').trim())) return optional

    const digitsRegex = /^[-]?\d*$/
    return digitsRegex.test((text || '').trim())
}

const isNumber = (text: string | any, optional: boolean): boolean => {
    if (isNaN(text)) {
        return false
    }

    if (typeof text === 'string' && isEmpty((text || '').trim())) {
        return optional
    }

    return !isNaN(Number(text))
}

const isNumberBetween = (value: string | number | any, min: number, max: number, optional: boolean): boolean => {
    let num: number = value

    if (typeof value === 'string') {
        if (isEmpty((value || '').trim())) {
            return optional
        }

        // parse
        num = Number(value)
    }

    return !isNaN(num) && num >= min && num <= max
}

const isLessNumber = (value: string | number | any, min: number, optional: boolean): boolean => {
    let num: number = value

    if (typeof value === 'string') {
        if (isEmpty((value || '').trim())) {
            return optional
        }

        // parse
        num = Number(value)
    }

    return !isNaN(num) && num >= min
}

const isMaxNumber = (value: string | number | any, max: number, optional: boolean): boolean => {
    let num: number = value

    if (typeof value === 'string') {
        if (isEmpty((value || '').trim())) {
            return optional
        }

        // parse
        num = Number(value)
    }

    return !isNaN(num) && num <= max
}

const isPositiveNumber = (value: string | number | any, optional: boolean): boolean => {
    let num: number = value

    if (typeof value === 'string') {
        if (isEmpty((value || '').trim())) {
            return optional
        }
        num = Number(value)
    }

    return !isNaN(num) && value >= 0
}

const areSame = (value: any, valueToCompare: any): boolean => {
    if (null === value && valueToCompare === null) return true
    if (null === value) return false
    if (null === valueToCompare) return false
    return value.toString() === valueToCompare.toString()
}

const isPhone = (text: string, optional: boolean): boolean => {
    if (isEmpty(text) || isEmpty((text || '').trim())) return optional

    const phoneNumber = text.replace(/\(|\)|\s+|-/g, '')
    return /^((\+?375)|(80))?(\d{2})\d{7}$/.test(phoneNumber)
}

const textMatch = (text: string, optional: boolean, pattern: string | RegExp): boolean => {
    if (isEmpty(text) || isEmpty((text || '').trim())) return optional

    return typeof pattern === 'string' ? new RegExp(pattern).test(text) : pattern.test(text)
}
const isValidText = (text: string | undefined): boolean => {
    return !!text?.toString()?.trim()
}

export const validators = {
    textLengthMatch,
    isEmail,
    isDigits,
    isNumber,
    isPhone,
    textMatch,
    areSame,
    isNumberBetween,
    isLessNumber,
    isMaxNumber,
    isPositiveNumber,
    isValidText
}
